module.exports = __webpack_public_path__ + "images/startbild-7707a46e21d1d9c3ce4ae65b51e280d3.jpg";